<svg viewBox="0 0 624 351" fill="none" xmlns="http://www.w3.org/2000/svg" {...$$props}>
  <g>
    <path
      d="M618.012 174.165L556.495 209.415L559.954 215.36L621.47 180.11L618.012 174.165Z"
      fill="#D2FAFF"
    />
    <path
      d="M182.243 296.24L179.596 302.582L245.228 329.563L247.875 323.221L182.243 296.24Z"
      fill="#D2FAFF"
    />
    <path
      d="M452.586 331.546L382.161 340.748L383.064 347.554L453.489 338.352L452.586 331.546Z"
      fill="#D2FAFF"
    />
    <path
      d="M107.166 295.315L105.376 301.946L174.002 320.196L175.792 313.565L107.166 295.315Z"
      fill="#D2FAFF"
    />
    <path
      d="M171.746 331.568L170.844 338.374L241.289 347.579L242.192 340.773L171.746 331.568Z"
      fill="#D2FAFF"
    />
    <path d="M525.235 349.945H454.202V356.81H525.235V349.945Z" fill="#D2FAFF" />
    <path
      d="M163.922 201.41L159.031 206.264L209.259 256.114L214.149 251.26L163.922 201.41Z"
      fill="#D2FAFF"
    />
    <path
      d="M654.296 258.843L585.751 277.071L587.541 283.702L656.087 265.473L654.296 258.843Z"
      fill="#D2FAFF"
    />
    <path d="M170.093 349.945H99.0603V356.81H170.093V349.945Z" fill="#D2FAFF" />
    <path
      d="M50.9481 242.272L48.3013 248.614L113.934 275.595L116.58 269.253L50.9481 242.272Z"
      fill="#D2FAFF"
    />
    <path
      d="M88.8526 178.997L84.6421 184.443L140.996 227.36L145.207 221.914L88.8526 178.997Z"
      fill="#D2FAFF"
    />
    <path
      d="M30.844 313.158L29.9412 319.964L100.38 329.167L101.283 322.362L30.844 313.158Z"
      fill="#D2FAFF"
    />
    <path
      d="M129.313 244.645L125.854 250.59L187.377 285.842L190.835 279.898L129.313 244.645Z"
      fill="#D2FAFF"
    />
    <path
      d="M422.78 264.838L366.437 307.747L370.648 313.193L426.991 270.284L422.78 264.838Z"
      fill="#D2FAFF"
    />
    <path
      d="M228.431 239.42L222.944 243.599L266.19 299.535L271.677 295.356L228.431 239.42Z"
      fill="#D2FAFF"
    />
    <path
      d="M573.388 242.246L507.75 269.229L510.396 275.572L576.035 248.588L573.388 242.246Z"
      fill="#D2FAFF"
    />
    <path
      d="M395.915 239.425L352.673 295.356L358.16 299.535L401.402 243.604L395.915 239.425Z"
      fill="#D2FAFF"
    />
    <path d="M667.31 349.945H596.277V356.81H667.31V349.945Z" fill="#D2FAFF" />
    <path
      d="M201.583 264.828L197.373 270.274L253.727 313.191L257.937 307.745L201.583 264.828Z"
      fill="#D2FAFF"
    />
    <path
      d="M593.413 313.138L522.988 322.34L523.89 329.146L594.316 319.944L593.413 313.138Z"
      fill="#D2FAFF"
    />
    <path
      d="M460.379 201.41L410.151 251.26L415.042 256.114L465.27 206.264L460.379 201.41Z"
      fill="#D2FAFF"
    />
    <path
      d="M494.982 244.644L433.436 279.911L436.894 285.856L498.441 250.589L494.982 244.644Z"
      fill="#D2FAFF"
    />
    <path
      d="M442.136 296.221L376.491 323.208L379.138 329.55L444.783 302.563L442.136 296.221Z"
      fill="#D2FAFF"
    />
    <path
      d="M535.459 179.005L479.132 221.901L483.343 227.347L539.67 184.451L535.459 179.005Z"
      fill="#D2FAFF"
    />
    <path
      d="M517.136 295.324L448.51 313.574L450.3 320.204L518.926 301.954L517.136 295.324Z"
      fill="#D2FAFF"
    />
    <path
      d="M486.733 46.406L451.241 107.418L457.231 110.85L492.723 49.8383L486.733 46.406Z"
      fill="#D2FAFF"
    />
    <path
      d="M223.568 12.0234L216.887 13.8L235.264 81.8702L241.945 80.0936L223.568 12.0234Z"
      fill="#D2FAFF"
    />
    <path
      d="M141.896 127.541L136.409 131.719L179.655 187.655L185.142 183.477L141.896 127.541Z"
      fill="#D2FAFF"
    />
    <path
      d="M206.615 91.5281L200.225 94.155L227.398 159.262L233.788 156.635L206.615 91.5281Z"
      fill="#D2FAFF"
    />
    <path
      d="M261.008 221.772L254.618 224.399L281.81 289.551L288.2 286.924L261.008 221.772Z"
      fill="#D2FAFF"
    />
    <path
      d="M260.318 148.158L253.637 149.935L272.025 218.045L278.706 216.268L260.318 148.158Z"
      fill="#D2FAFF"
    />
    <path
      d="M278.498 73.3638L271.64 74.2598L280.912 144.156L287.769 143.26L278.498 73.3638Z"
      fill="#D2FAFF"
    />
    <path
      d="M208.591 168.482L202.602 171.914L238.125 232.98L244.115 229.548L208.591 168.482Z"
      fill="#D2FAFF"
    />
    <path
      d="M-30.0031 258.833L-31.7932 265.464L36.7525 283.693L38.5427 277.062L-30.0031 258.833Z"
      fill="#D2FAFF"
    />
    <path d="M28.033 349.945H-43V356.81H28.033V349.945Z" fill="#D2FAFF" />
    <path
      d="M6.30764 174.159L2.84937 180.104L64.3238 215.329L67.782 209.384L6.30764 174.159Z"
      fill="#D2FAFF"
    />
    <path
      d="M137.567 46.4056L131.577 49.8379L167.07 110.85L173.06 107.418L137.567 46.4056Z"
      fill="#D2FAFF"
    />
    <path
      d="M63.4703 101.711L58.5796 106.565L108.807 156.415L113.698 151.561L63.4703 101.711Z"
      fill="#D2FAFF"
    />
    <path
      d="M482.361 127.565L439.119 183.496L444.606 187.674L487.848 131.744L482.361 127.565Z"
      fill="#D2FAFF"
    />
    <path
      d="M415.719 168.483L380.186 229.567L386.175 232.999L421.709 171.915L415.719 168.483Z"
      fill="#D2FAFF"
    />
    <path
      d="M400.76 12.0253L382.383 80.0955L389.063 81.8721L407.441 13.802L400.76 12.0253Z"
      fill="#D2FAFF"
    />
    <path
      d="M345.823 73.3405L336.555 143.209L343.412 144.105L352.68 74.2365L345.823 73.3405Z"
      fill="#D2FAFF"
    />
    <path
      d="M363.993 148.161L345.594 216.311L352.275 218.087L370.674 149.937L363.993 148.161Z"
      fill="#D2FAFF"
    />
    <path
      d="M560.834 101.711L510.606 151.561L515.497 156.415L565.725 106.565L560.834 101.711Z"
      fill="#D2FAFF"
    />
    <path
      d="M417.693 91.5075L390.507 156.646L396.897 159.273L424.083 94.1344L417.693 91.5075Z"
      fill="#D2FAFF"
    />
    <path
      d="M290.423 286.163L302.008 329.087L279.626 290.604L273.637 294.037L296.018 332.519L264.368 301.107L259.478 305.96L291.128 337.373L252.354 315.159L248.896 321.104L287.67 343.317L244.421 331.819L242.63 338.45L285.879 349.948H241.122V356.813H285.879H338.417H383.181V349.948H338.417L381.666 338.45L379.875 331.819L336.632 343.317L375.4 321.104L371.941 315.159L333.167 337.373L364.824 305.96L359.934 301.107L328.277 332.519L350.666 294.037L344.676 290.604L322.288 329.087L333.88 286.163L327.198 284.385L315.606 327.309V282.889H308.69V327.309L297.104 284.385L290.423 286.163Z"
      fill="#D2FAFF"
    />
    <path d="M315.616 141.891H308.699V211.93H315.616V141.891Z" fill="#D2FAFF" />
    <path
      d="M297.015 212.688L290.158 213.584L299.489 283.929L306.347 283.033L297.015 212.688Z"
      fill="#D2FAFF"
    />
    <path d="M315.616 0.898926H308.699V71.3978H315.616V0.898926Z" fill="#D2FAFF" />
    <path
      d="M327.309 213.165L318.04 283.041L324.898 283.937L334.167 214.061L327.309 213.165Z"
      fill="#D2FAFF"
    />
    <path
      d="M363.359 221.826L336.182 286.946L342.572 289.573L369.75 224.453L363.359 221.826Z"
      fill="#D2FAFF"
    />
  </g>
</svg>
